import { render, staticRenderFns } from "./holiday-log.vue?vue&type=template&id=511088a5"
import script from "./holiday-log.vue?vue&type=script&lang=js"
export * from "./holiday-log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports